<template>
    <div class="container">

        <h1 class="center">Cart</h1>
        <div class="spacer"></div>
        <!--Featured-->


        <div v-if="localItems.length == 0">No items are currently in your cart.</div>
        <cart-item :item="item" v-for="item, i in localItems"
                   :key="i"
                   :adjustments="localPricing.adjustments.messages"
                   @refresh="refresh"
                   @updating="maskPricing"
        ></cart-item>

        <div class="spacer"></div>
        <div class="row">

            <promo :promos="localPromos"
                   :adjustments="localPricing.adjustments.messages"
                   @refresh="refresh"
                   @updating="maskPricing"
            ></promo>

            <div class="col-md-1"></div>

            <div class="col-md subtotals pt-0">
                <div v-if="reloadPricing">
                    <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
                <div v-if="!reloadPricing">
                  <div v-if="isIterativePaymentType() && canCheckout">
                    <span class="newprice">NEW!</span>
                    <span>Payments Today: </span>
                    <select class="custom-select" :value="selectedPaymentsToday" @change="onPaymentsTodayChange">
                        <option
                          v-for="multiplePaymentOption in getPaymentsTodayOptions()"
                          v-bind:key="multiplePaymentOption.label"
                          :value="multiplePaymentOption.value"
                        >
                          {{ multiplePaymentOption.label }}
                        </option>
                    </select>
                  </div>
                       <div class="row total">
                        <div class="col-8">TODAY'S TOTAL</div>
                        <div class="col-1">${{ getTodaysTotal() }}<sup>*</sup></div>
                    </div>
                    <div class="row">
                        <div class="col-md-8"></div>
                        <div class="col-md-3">
                            <small class="text">* plus tax</small>
                        </div>
                    </div>
                </div>
            </div>
            <a class="btn btn-danger cart" href="/order" v-if="(canCheckout || freeCheckoutEnabled) && !reloadPricing">Proceed to Checkout</a>
            <br>
            <a class="btn btn-danger cart" href="javascript:history.back()">Continue Shopping</a>

        </div>

        <div v-if="!canCheckout && !reloadPricing && localItems.length !== 0">
            <span class="text-danger">{{ localPricing.nonMatchingPriceErrorMessage }}</span>
        </div>


    </div>


</template>

<script>
    import CartItem from './CartItem.vue';
    import Pricing from '../Pricing.vue';
    import Promo from '../Promo.vue';

    import { ServiceFactory } from '../../../../../../shared/assets/js/services/ServiceFactory';
    const CartService = ServiceFactory.get('cart');
    const PricingService = ServiceFactory.get('pricing');
    const PromoService = ServiceFactory.get('promos');

    export default {

        props: ['cartItems', 'pricing', 'promos'],

        data() {
            return {
                cart: null,
                localItems: null,
                localPricing: null,
                localPromos: null,
                reloadPricing: false,
                selectedPaymentsToday: null,
            }
        },

        created() {
            this.localItems = this.cartItems;
            this.localPricing = this.pricing;
            this.localPromos = this.promos;
            this.selectedPaymentsToday = this.localPricing.paymentsToday;
        },

        mounted() {
            this.sendConvertCart();
        },

        components: {CartItem, Pricing, Promo},

        computed: {
            canCheckout() {
                return !this.localPricing.enforceMatchingPrices || this.localPricing.hasMatchingPrices;
            },

            freeCheckoutEnabled() {
                if (!this.localPromos || this.localPromos.count <= 0) {
                    return false;
                }

                let freeAtCheckout = this.localPromos.find((promo) => {
                   return promo.type == 'freeAtCheckout';
                });

                return freeAtCheckout && this.localPricing <= 0;
            }
        },

        methods: {

            maskPricing() {
                this.reloadPricing = true;
            },

            async refresh() {
                await this.refreshPricing();
                await this.refreshCart();
                await this.refreshPromos();

                this.sendConvertCart(true);
            },

            async refreshCart() {
                const request = await CartService.get();
                this.localItems = request.data;
                if (this.localItems) {
                    let count = 0;
                    for(const [key, value] of Object.entries(this.localItems)) {
                        let quantity = Number.parseInt(value.qty);
                        if(quantity && quantity > 0) {
                            count += quantity;
                        }
                    }
                    this.$store.commit('setCartCount', count);
                }
            },

            async refreshPricing() {
                const request = await PricingService.getNonEcommercePricing();
                this.localPricing = request.data;
                this.reloadPricing = false;
                this.selectedPaymentsToday = this.localPricing.paymentsToday;
            },

            async refreshPromos() {
                const request = await PromoService.get();
                this.localPromos = request.data;
            },

            calculatePrice() {
                let count = 0;
                Object.keys(this.localItems).forEach(item => {
                    count += this.localItems[item].qty;
                });

                return this.formatCurrency(10.00 * count);
            },

            hasPromo() {
                return this.localPromos.length > 0;
            },

            formatCurrency(val) {
                return parseFloat(val).toFixed(2);
            },

            isIterativePaymentType() {
                const selectedPriceType = this.getSelectedPriceType();
                return selectedPriceType === 'weekly' || selectedPriceType === 'monthly';
            },

            getSelectedPriceType() {
                return this.localPricing.selectedPriceType;
            },

            getPaymentsTodayOptions() {
                const selectedPriceType = this.getSelectedPriceType();
                const maxPaymentsToday = this.localPricing.maxPaymentsToday;
                if(selectedPriceType === 'weekly') {
                    return new Array(maxPaymentsToday)
                        .fill({})
                        .map((_, payments) => ({
                            label: `${payments + 1} Weekly Payment${payments > 0 ? 's' : ''}`,
                            value: payments + 1,
                        }));
                }

                return [{
                    value: 1,
                    label: '1 Monthly Payment'
                }];
            },

            onPaymentsTodayChange(e) {
                const newValue = e.target.value;
                this.setPaymentsToday(newValue);
            },

            async setPaymentsToday(paymentsToday){
                this.maskPricing();
                await CartService.setPaymentsToday(paymentsToday);
                this.refresh();
            },

            getTodaysTotal() {
                return this.formatCurrency(this.localPricing.subtotal);
            },

            sendConvertCart(isMiniCart = false) {
                const regex = new RegExp(/^.*\//);
                const baseUrl = regex.exec(window.location.href);
                const localItemKeys = Object.keys(this.localItems);
                const ccItems = localItemKeys.map(itemKey => {
                    const { options, product, qty} = this.localItems[itemKey];
                    const price = product.pricing.find(({id}) => id === options.price_id);
                    return ({
                        id: product.id,
                        name: product.name,
                        url: `${baseUrl}${product.url}`,
                        image: product.images['800x800'][0],
                        price: price.amount,
                        currency: 'USD',
                        quantity: parseInt(qty),
                    });
                });

                const ccEvent = isMiniCart ? 'miniCartViewed' : 'cartViewed';

                const ccCart = {
                    items: ccItems,
                    currency: 'USD',
                    total: parseFloat(this.getTodaysTotal()),
                };

                window.ccLayer = window.ccLayer || [];
                ccLayer.push({
                    ccEvent,
                    src: 'custom',
                    ...ccCart,
                });
            }
        }

    }
</script>
